<template>
  <div class="calc_susong">
    <div class="shuru">
      <sub-title text="诉讼费计算器" />
      <el-form ref="form" :model="form" label-width="100px" class="calcform">
        <el-form-item label="费用类型：">
          <el-select
            v-model="form.sel1"
            placeholder="申请费"
            style="width: 100%"
            @change="sel1change"
          >
            <el-option
              v-for="(item, index) in select1"
              :key="index"
              :label="item.text"
              v-model="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="案件类型：">
          <el-select
            v-model="form.sel2"
            :placeholder="select2[0]"
            style="width: 100%"
            @change="sel2change"
          >
            <el-option
              v-for="item in select2"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="诉讼标的：" class="noribg">
          <el-input v-model="form.name"> </el-input>
          <div class="ribgtext">元</div>
        </el-form-item>

        <el-form-item class="anniu text_center">
          <div class="btn submit">开始计算</div>
          <div class="btn" @click="reset">重置</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="shuchu mt50">
      <sub-title text="计算结果：" />
      <div class="shuchutext FontSize12" v-html="shuchutext"></div>
      <div class="tishitext">
        <i class="el-icon-warning ic"></i>
        <span>注：</span
        >预估结果仅供参考，实际费用以当地实际情况为准！计算单位：人民币。
      </div>
      <sub-title text="相关条例法规" class="mt50" />
      <div class="xgtl mt30">
        本诉讼费计算器的计算方法按现行
        <a href="#">《诉讼费用交纳办法》</a> (2007年4月1日起施行) 编制。
      </div>
    </div>
    <div class="tjlaw mt50">
      <sub-title text="律官网推荐律师" />
      <div class="between mt30">
          <homelay-itw v-for="item in 4" :key="item" :consult-or-more="true" class="homelay_itw" />
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
import homelayItw from "../../home/components/layItemWin";
export default {
  components: {
    subTitle,
    homelayItw,
  },
  data: () => ({
    form: {},
    select1: [
      {
        text: "申请费",
        value: 0,
        valuelist: [
          "离婚案件",
          "侵害人格权案件",
          "知识产权民事案件",
          "非财产案件",
          "财产案件",
          "劳动争议案件",
          "商标、专利、海事行政案件",
          "其他行政案件",
          "管辖权异议",
        ],
      },
      {
        text: "案件受理费",
        value: 1,
        valuelist: [
          "申请执行",
          "申请财产保全",
          "申请支付令",
          "申请公示催告",
          "申请撤销仲裁裁决或认定仲裁协议效力",
          "申请破产案件",
          "申请设立海事赔偿责任限制基金",
          "申请海事强制令",
          "申请船舶优先权催告",
          "申请海事债权登记",
          "申请共同海损理算",
        ],
      },
    ],
    select2: [],
    // shuchutext: `<p style="color:#333"> <span style='color: red'>50</span>元
    // -<span style='color: red'>100</span>元`,
    shuchutext: `暂无结果，赶紧算算吧！`,
  }),
  beforeMount() {
    this.select2 = this.select1[0].valuelist;
  },
  methods: {
    sel1change(e) {
      console.log(e);
      this.select2 = this.select1[e].valuelist;
    },
    sel2change(e) {
      console.log(e);
    },
    // 重置
    reset(){
        this.form = {}
    }
  },
};
</script>

<style lang="scss" scoped>
.calc_susong {
  width: 100%;
  padding: 42px 54px;
  background-color: #fff;
  .subtitle {
    font-size: 16px;
    line-height: 16px;
    font-weight: bold;
  }
  .mt50 {
    margin-top: 50px;
  }
  .mt30 {
    margin-top: 30px;
  }
  .shuru {
    padding-bottom: 50px;
    border-bottom: 1px solid #eeeeee;
    .calcform {
      margin-top: 50px;
      ::v-deep .el-form-item {
        width: 570px;
      }
      ::v-deep .el-form-item__label {
        font-weight: bold;
      }
      ::v-deep .el-input.is-focus .el-input__inner {
        border-color: #c9c9c9;
      }
      ::v-deep .el-input__inner:focus {
        border-color: #c9c9c9;
      }
      .noribg {
        position: relative;
        .ribgtext {
          font-size: 14px;
          color: #999999;
          position: absolute;
          right: 16px;
          top: 0;
        }
      }
      .anniu {
        margin-top: 50px;
        margin-bottom: 0;
        .btn {
          display: inline-block;
          line-height: 1;
          white-space: nowrap;
          cursor: pointer;
          background: #fff;
          border: 1px solid #dcdfe6;
          color: #606266;
          text-align: center;
          font-weight: 500;
          padding: 12px 20px;
          font-size: 14px;
          border-radius: 4px;
          margin-right: 30px;
        }
        .submit {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
        }
      }
    }
  }
  .shuchu {
    padding-bottom: 50px;
    border-bottom: 1px solid #eeeeee;
    .shuchutext {
      width: 300px;
      color: #ccc;
      border: 1px solid #e6e6e6;
      padding: 23px 20px;
      margin: 30px 0;
      span {
        color: rgb(255, 0, 0);
      }
    }
    .tishitext {
      font-size: 12px;
      color: #999;
      span {
        color: #666;
        margin-left: 10px;
      }
      .ic {
        color: #999;
        font-size: 20px;
        vertical-align: -0.15em;
      }
    }
    .xgtl {
        font-size: 14px;
      a {
        color: #0057ff;
        text-decoration: none;
        &:hover {
          color: #ec3b3b;
        }
      }
    }
  }
  .tjlaw{
   .homelay_itw{
       width: 194px;
       height: 250px;
   }   
  }
}
</style>